import { Registry, withRegistry } from '@bem-react/di';

import { AssignmentAddSchoolControl } from 'common.components/lesson-view.assignment/__add-school-control/assignment__add-school-control';

import LessonViewBase from './lesson-view';
import { cnLessonView } from './registry';

const lessonViewRegistry = new Registry({ id: cnLessonView() });
lessonViewRegistry.set('AssignmentAddSchoolControl', AssignmentAddSchoolControl);
export const LessonViewWithAddSchoolControl = withRegistry(lessonViewRegistry)(LessonViewBase);
